import { fetchFromSubgraph } from "./subgraph";
import { mapGraphQl as mapGraphQlRole, ROLE_FIELDS } from "./fetchRole";
import { getRolesModId } from "./ids";
const MOD_QUERY = `
query RolesMod($id: ID!, $blockNumber: Int) {
  rolesModifier(id: $id, blockNumber: $blockNumber) {
    address
    owner
    avatar
    target 
    roles {
      ${ROLE_FIELDS}
    }
    allowances {
      key
      refill
      maxRefill
      period
      balance
      timestamp
    }
    unwrapAdapters {
      targetAddress
    }
  }
}
`;
export const fetchRolesMod = async ({ chainId, address, blockNumber }, options) => {
    const { rolesModifier } = await fetchFromSubgraph({
        query: MOD_QUERY,
        variables: {
            id: getRolesModId(chainId, address),
            blockNumber,
        },
        operationName: "RolesMod",
    }, options);
    if (!rolesModifier) {
        return null;
    }
    return mapGraphQl(rolesModifier);
};
const mapGraphQl = (rolesModifier) => ({
    ...rolesModifier,
    roles: rolesModifier.roles.map(mapGraphQlRole),
    allowances: rolesModifier.allowances.map((allowance) => ({
        key: allowance.key,
        refill: BigInt(allowance.refill),
        maxRefill: BigInt(allowance.maxRefill),
        period: BigInt(allowance.period),
        balance: BigInt(allowance.balance),
        timestamp: BigInt(allowance.timestamp),
    })),
    multiSendAddresses: rolesModifier.unwrapAdapters
        .filter(({ selector, adapterAddress }) => selector === "0x8d80ff0a" &&
        adapterAddress === "0x93b7fcbc63ed8a3a24b59e1c3e6649d50b7427c0")
        .map((adapter) => adapter.targetAddress),
});
